module.exports = __webpack_public_path__ + "img/DSC_6955.85721e71.jpg";